<template>
    <uw-content title="异常工单">
        <template slot="prefix">
            <el-button size="mini" :type="search.state == null ? 'primary' : 'text'" @click="search.state = null; TableSearch()">全部</el-button>
            <el-button size="mini" :type="search.state == 0 ? 'primary' : 'text'" @click="search.state = 0; TableSearch()">待核实</el-button>
            <el-button size="mini" :type="search.state == 1 ? 'primary' : 'text'" @click="search.state = 1; TableSearch()">已核实</el-button>
        </template>
        <uw-table :show-header="false">
            <template slot="data">
                <vxe-table ref="xTable" :data="table" :loading="loading" :seq-config="{startIndex: page.size * (page.current - 1)}" height="100%">
                    <vxe-column width="60" type="seq" title="序号"></vxe-column>
                    <vxe-column width="120" field="p" title="紧急程度">
                        <template #default="{ row }">
                            <el-tag v-if="row.state == 0" size="small" effect="plain" type="danger">待核实</el-tag>
                            <el-tag v-if="row.state == 1" size="small" effect="plain" type="primary">已核实</el-tag>
                        </template>
                    </vxe-column>
                    <vxe-column width="160" field="wo.number" title="工单编号">
                        <template #default="{ row }">
                            <span class="el-span-primary" @click="$refs.woDrawer.Open(row.wo.id)"><i class="el-icon-paperclip w-margin-r-5"></i>{{ row.wo.number }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column min-width="160" field="wo.name" title="工单名称"></vxe-column>
                    <vxe-column min-width="160" field="describe" title="异常描述"></vxe-column>
                    <vxe-column width="110" title="核实人">
                        <template #default="{ row }">
                            <div style="display: flex; align-items: center; justify-content: flex-start;">
                                <el-avatar style="margin-right: 5px;" :size="26" :src="row.confirm_users?.avatar"> {{ row.confirm_users?.name[0] }} </el-avatar>
                                {{  row.confirm_users?.name }}
                            </div>
                        </template>
                    </vxe-column>
                    <vxe-column width="140" field="confirm_describe" title="核实结果/处理结果"></vxe-column>
                    <vxe-column width="140" field="confirm_at" title="核实时间/处理时间"></vxe-column>
                    <vxe-column width="60" title="操作" align="center">
                        <template #default="{ row }">
                            <el-link type="primary" @click="UpdateConfirm(row.id)" :disabled="!!row.state" :underline="false">核实</el-link>
                        </template>
                    </vxe-column>
                </vxe-table>
            </template>
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>
        </uw-table>
        <pm-wo-drawer ref="woDrawer" @onChange="TableSearch" />
    </uw-content>
</template>
<script>
export default {
    data() {
        return {
            table: [],
                        page: {
                total: 0,
                size: 50,
                current: 1,
            },
                        search: {
                template_id: null,
                number: null,
                name: null,
                state: 0,
                projects_id: null,
                customer_id: null,
                user_sending_id: null,
                user_receive_id: null,
                range_at: null
            },
                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },
        computed: {
        loading () {
            return !!this.$store.state.httpRequestCount
        }
    },
    mounted() {
        this.TableSearch()
    },
    methods: {
                TableSearch() {
            this.$http.post(
                '/9api/pm/wo-alarm/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['wo', 'confirm_users']
                }
            ).then(rps => {
                                this.page.total = rps.data.total
                this.table = rps.data.body
                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }
            })
        },
                UpdateConfirm(id) {
            this.$prompt('核实结果/处置结果', '核实', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(({ value }) => {
                this.$http.post('/9api/pm/wo-alarm/update-confirm', { id: id, confirm_describe: value  }).then(rps => {
                    this.TableSearch()
                })
            })
        }
    }
}
</script>